module.exports = __webpack_public_path__ + "media/icons/add-item-ec73afc1.png";